import React, {useContext, useEffect} from 'react'
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import {Form, AutoComplete} from "antd";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const {Option} = AutoComplete

const OfferUpdateStock = ({rowIndex, record}) => {
    const [form] = Form.useForm()
    const {stocks, bidContent} = useContext(OfferEditContext)
    const [bidList, setBidList] = bidContent
    const [stockList] = stocks


    useEffect(() => {
        if (record.stock){
            form.setFieldsValue({
                [`offerStock-${rowIndex}`]: record.stock.text
            })
        }

    }, [rowIndex, record])

    const handleStockChange = (value, option) => {
        if (option.key) {
            const matchedStock = stockList.find(item => Number(item.id) === Number(option.key))
            const newList = replaceIndexAt(
                bidList,
                {
                    ...record,
                    stock: {...matchedStock},
                    selectedCurrency: matchedStock.currency,
                    linePrice: matchedStock.price
                },
                rowIndex
            )
            setBidList(newList)
        }
    }

    return (
        <React.Fragment>
            <div className={'offer-stock'}>
                <Form form={form}>
                    <Form.Item name={`offerStock-${rowIndex}`}>
                        <AutoComplete
                            className={'auto-complete'}
                            dropdownClassName={'offer-stock-options'}
                            onChange={handleStockChange}
                            filterOption={(inputValue, option) =>
                                option.value.toLocaleLowerCase().indexOf(inputValue.toLocaleLowerCase()) !== -1
                            }
                        >
                            {stockList.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                </Form>
            </div>
        </React.Fragment>
    )
}
export default OfferUpdateStock